<template>
  <banner :rounded="true" :showImage="false" :isWhiteBanner="true" class="bg-primaryDark">
    <div
      class="
        text-white
        gap-4
        grid
        justify-items-center
        text-center
        md:text-left
        grid-cols-banner
        md:items-start
      "
    >
      <img
        src="../assets/account-expired-icon.svg"
        alt="Account Expired Icon"
        width="75"
        height="75"
        class="h-18 w-auto"
      />
      <div class="grid md:flex gap-1 text-white">
        <div class="md:pr-40 md:pt-2">
          <p class="text-base font-semibold whitespace-nowrap">{{ primaryMessage }}</p>
          <p class="text-sm whitespace-nowrap">{{ secondaryMessage }}</p>
        </div>
        <custom-button
          variant="white"
          size="normal"
          class="font-semibold w-full md:w-72 md:h-11 mt-2 justify-self-center md:justify-self-start"
          @click="selectNbfc(creditAccountInfo?.nbfcName)"
          :loading="isLoading"
          >Renew</custom-button
        >
      </div>
    </div>
  </banner>
</template>
<script>
import { mapGetters } from 'vuex';
import Banner from './Banner.vue';
import CustomButton from './CustomButton.vue';

export default {
  name: 'ApplicationUnderReviewCard',
  components: {
    Banner,
    CustomButton,
  },
  props: {
    primaryMessage: {
      type: String,
      required: true,
    },
    secondaryMessage: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      isLoading: undefined,
    };
  },
  computed: {
    ...mapGetters(['creditAccountInfo', 'applicationId']),
  },
  methods: {
    selectNbfc(nbfc) {
      this.isLoading = true;
      const type = 'renewal';
      const params = {
        applicationId: this.applicationId,
        patchParams: {
          nbfc,
          type,
        },
      };
      this.$store
        .dispatch('applicationSelectNbfc', params)
        .then(() => {
          this.isLoading = false;
          this.$router.push({
            name: 'Mandate',
            query: {
              redirect: 'Loan Agreement',
            },
          });
        })
        .catch(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.grid-cols-banner {
  @media only screen and (min-width: 640px) {
    grid-template-columns: auto 1fr;
  }
}
</style>
